import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import PapperBlock from '../../../components/PapperBlock';
import StreamBlockForm from '../StreamBlockForm';
import { getBlockById, updateBlockById } from '../requests';
import { StreamsIcon } from '../../../constants/icons';
import { ADMIN_STREAMS_A_ROUTE } from '../../../constants/routes';

export default function AudioStreamUpdate() {
  const [dataAbout, setData] = useState({});
  const [loaded, setLoaded] = useState(false);
  const params = useParams();
  const { id } = params;
  const processingRequest = async () => {
    setData((await getBlockById(id)).data);
    setLoaded(true);
  };
  const history = useHistory();
  const submitHandler = async (data) => {
    const response = await updateBlockById(data);
    if (response.ok) {
      history.push(ADMIN_STREAMS_A_ROUTE);
    }
  };
  useEffect(() => {
    processingRequest();
  }, []);

  return (
    <PapperBlock title="Обновить стрим" icon={<StreamsIcon />}>
      {loaded && <StreamBlockForm submitHandler={submitHandler} data={dataAbout} />}
    </PapperBlock>
  );
}
